export const UPDATE_LOAN_DETAILS = "UPDATE_LOAN_DETAILS";
export const RESET_LOAN_DETAILS = "RESET_LOAN_DETAILS";

export const UPDATE_LOAN_PAYMENT_DETAILS = "UPDATE_LOAN_PAYMENT_DETAILS";
export const UPDATE_LOAN_PAYMENT_YEAR = "UPDATE_LOAN_PAYMENT_YEAR";
export const UPDATE_LOAN_PRE_PAYMENT_OPTIONS =
  "UPDATE_LOAN_PRE_PAYMENT_OPTIONS";
export const REMOVE_PRE_PAYMENT_OPTION = "REMOVE_PRE_PAYMENT_OPTION";
